import React, { FC } from 'react';
import { Button, Card, CardBody } from '@heroui/react';
import { InfoIconBlue, InfoSuccessGreen, SuccesAlertIc } from '../icons';
import { Icon } from '@iconify/react';
import Typography from '../typography/Typography';

type AlertBlockProps = {
  data: DataAlert[];
  addContent?: React.ReactNode;
  customIcon?: any;
  type?: 'default' | 'rounded';
  className?: string;
  titleColor?: string;
};

type DataAlert = {
  severity: 'info' | 'success' | 'warning' | 'error';
  title?: string;
  description?: string;
  descriptions?: string[];
  icon?: React.ReactNode;
};
const AlertBlock: FC<AlertBlockProps> = ({ data, addContent, className, type, titleColor }) => {
  const getIcon = (severity?: string) => {
    switch (severity) {
      case 'info':
        return <InfoIconBlue />;
      case 'success':
        return <InfoSuccessGreen />;
      case 'warning':
        return <InfoIconBlue />;
      case 'error':
        return (
          <Icon
            icon="mingcute:information-fill"
            width="24"
            height="24"
            className="text-auth-strength-weak"
          />
        );
      default:
        return null;
    }
  };
  const getColor = (severity?: string) => {
    switch (severity) {
      case 'info':
        return '#006FEE';
      case 'success':
        return '#0E793C';
      case 'warning':
        return '#0E793C';
      case 'error':
        return '#F31260';
      default:
        return null;
    }
  };
  if (type === 'rounded') {
    if (data && data.length === 1 && data[0].severity === 'success') {
      return (
        <div className="flex flex-col gap-2">
          {data &&
            data.length > 0 &&
            data.map((item, index) => (
              <div key={index} className="bg-green-50 border border-green-200 rounded-xl py-3 px-4">
                <div className="flex items-center gap-4">
                  <div className="icon size-8 md:size-9">
                    <SuccesAlertIc />
                  </div>
                  <span className="text-successDark text-sm leading-5 font-medium">
                    {item?.description}
                  </span>
                </div>
              </div>
            ))}
        </div>
      );
    }
    return (
      <div className="flex w-full flex-col gap-2">
        {data &&
          data.length > 0 &&
          data.map((item, index) => (
            <div
              key={index}
              className={`w-full bg-auth-error-bg border-2 border-auth-error-border rounded-3 py-3 px-4 shadow-sm ${className}`}
            >
              <div className="flex items-center gap-4">
                <div className="size-10 bg-auth-error-bg border border-auth-error-border rounded-[1.875rem] flex items-center justify-center flex-shrink-0">
                  <Icon
                    icon="mingcute:information-fill"
                    width="19"
                    height="19"
                    className="text-auth-error-text"
                  />
                </div>
                <p className="text-auth-error-text text-sm font-medium leading-5">
                  {item?.description}
                </p>
              </div>
            </div>
          ))}
      </div>
    );
  }
  // Get border color based on first item severity (for single alerts) or default
  const borderColor = data?.[0]?.severity ? getColor(data[0].severity) : '#006FEE';

  return (
    <Card
      className={`border border-l-[0.1875rem] rounded-r-3 rounded-l-none shadow-sm bg-gray-98 ${className}`}
      style={{ borderLeftColor: borderColor || '#006FEE' }}
    >
      <CardBody className="p-4 flex flex-col gap-6 ">
        {data &&
          data.length > 0 &&
          data.map((item, index) => (
            <div key={index} className="flex items-start gap-4">
              {/* @ts-ignore */}
              <div className="icon size-8 md:size-9">
                <div className="size-full [&>*]:size-full [&_*]:!left-0 [&_*]:!top-0">
                  {item?.icon || item?.icon === null ? item?.icon : getIcon(item?.severity)}
                </div>
              </div>
              <div className="max-w-[46.875rem] flex flex-col items-start">
                <Typography
                  variant="body2"
                  className={`font-medium leading-5 mb-0.5`}
                  style={{ color: titleColor || getColor(item?.severity) || '#006fee' }}
                >
                  {item?.title || 'Подтвердите код'}
                </Typography>
                {item?.descriptions && item?.descriptions.length > 0
                  ? item?.descriptions.map((desc: any, idx: any) => (
                      <>
                        <Typography variant="body2" key={idx} className="text-auth-muted leading-5">
                          <span dangerouslySetInnerHTML={{ __html: desc }} />
                        </Typography>
                        {idx + 1 === item?.descriptions?.length ? null : (
                          <>
                            <br />
                          </>
                        )}
                      </>
                    ))
                  : !addContent && (
                      <Typography variant="body2" className="text-auth-muted leading-5">
                        <span dangerouslySetInnerHTML={{ __html: item?.description || '' }} />
                      </Typography>
                    )}
                {addContent && addContent}
                {/* <p className="text-sm text-partner leading-5 border-[1px] py-0.5 rounded-5 bg-husky px-2 border-husky ">
                {generatedCode}
              </p> */}
              </div>
            </div>
          ))}
      </CardBody>
    </Card>
  );
};

export default AlertBlock;
